import { PlusIcon } from '../../../../../assets/icons/index';
import { AppFormattedMessage } from '../../../../../components/app-formatted-message/index';
import Button from '../../../../../components/button/index';
import {
  EmptyState as EmptyStateBase,
  EmptyStateImageVariant,
  EmptyStateVariant,
} from '../../../../../components/empty-state/index';
import { useLocale } from '../../../../../hooks/index';
import { selectedCompanyStorage } from '../../../../../storage/company/selected-company.util';
import { AccessRole } from '../../../../../types/stakeholder.types';
import { TemplateFormStore } from '../../store/template-form.store';

export const TemplatesEmptyState = () => {
  const { messagesLocale } = useLocale();
  const toggleAddState = TemplateFormStore(({ toggleAddState }) => toggleAddState);
  const company = selectedCompanyStorage(({ company }) => company);
  const hideTemplateCreation = company?.stakeholder?.accessRole === AccessRole.AUDITOR;
  return (
    <EmptyStateBase
      colorScheme={EmptyStateVariant.ORANGE}
      description={messagesLocale['TEMPLATES_EMPTY_DESCRIPTION']}
      imageVariant={EmptyStateImageVariant.CLIPBOARD}
      text={messagesLocale['TEMPLATES_EMPTY_TITLE']}
    >
      {!hideTemplateCreation && (
        <Button
          className="flex h-9 items-center gap-2 px-4 py-2"
          onClick={() => toggleAddState(true)}
        >
          <PlusIcon />
          <AppFormattedMessage id="CREATE_TEMPLATE" />
        </Button>
      )}
    </EmptyStateBase>
  );
};
